// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var TaskType;
(function (TaskType) {
    TaskType["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
    TaskType["TYPE_SCHEDULING"] = "TYPE_SCHEDULING";
    TaskType["TYPE_WAITLIST"] = "TYPE_WAITLIST";
    TaskType["TYPE_PATIENT_CARE"] = "TYPE_PATIENT_CARE";
    TaskType["TYPE_INSURANCE"] = "TYPE_INSURANCE";
    TaskType["TYPE_BILLING"] = "TYPE_BILLING";
    TaskType["TYPE_OTHER"] = "TYPE_OTHER";
})(TaskType || (TaskType = {}));
export var TaskType_index;
(function (TaskType_index) {
    TaskType_index[TaskType_index["TYPE_UNKNOWN"] = 0] = "TYPE_UNKNOWN";
    TaskType_index[TaskType_index["TYPE_SCHEDULING"] = 1] = "TYPE_SCHEDULING";
    TaskType_index[TaskType_index["TYPE_WAITLIST"] = 2] = "TYPE_WAITLIST";
    TaskType_index[TaskType_index["TYPE_PATIENT_CARE"] = 3] = "TYPE_PATIENT_CARE";
    TaskType_index[TaskType_index["TYPE_INSURANCE"] = 4] = "TYPE_INSURANCE";
    TaskType_index[TaskType_index["TYPE_BILLING"] = 5] = "TYPE_BILLING";
    TaskType_index[TaskType_index["TYPE_OTHER"] = 6] = "TYPE_OTHER";
})(TaskType_index || (TaskType_index = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    TaskStatus["STATUS_TODO"] = "STATUS_TODO";
    TaskStatus["STATUS_IN_PROGRESS"] = "STATUS_IN_PROGRESS";
    TaskStatus["STATUS_COMPLETED"] = "STATUS_COMPLETED";
    TaskStatus["STATUS_DELETED"] = "STATUS_DELETED";
})(TaskStatus || (TaskStatus = {}));
export var TaskStatus_index;
(function (TaskStatus_index) {
    TaskStatus_index[TaskStatus_index["STATUS_UNKNOWN"] = 0] = "STATUS_UNKNOWN";
    TaskStatus_index[TaskStatus_index["STATUS_TODO"] = 1] = "STATUS_TODO";
    TaskStatus_index[TaskStatus_index["STATUS_IN_PROGRESS"] = 2] = "STATUS_IN_PROGRESS";
    TaskStatus_index[TaskStatus_index["STATUS_COMPLETED"] = 3] = "STATUS_COMPLETED";
    TaskStatus_index[TaskStatus_index["STATUS_DELETED"] = 4] = "STATUS_DELETED";
})(TaskStatus_index || (TaskStatus_index = {}));
export var TaskSource;
(function (TaskSource) {
    TaskSource["SOURCE_UNKNOWN"] = "SOURCE_UNKNOWN";
    TaskSource["SOURCE_CALL_INTELLIGENCE"] = "SOURCE_CALL_INTELLIGENCE";
    TaskSource["SOURCE_TASK_CENTER"] = "SOURCE_TASK_CENTER";
    TaskSource["SOURCE_MESSAGING"] = "SOURCE_MESSAGING";
})(TaskSource || (TaskSource = {}));
export var TaskSource_index;
(function (TaskSource_index) {
    TaskSource_index[TaskSource_index["SOURCE_UNKNOWN"] = 0] = "SOURCE_UNKNOWN";
    TaskSource_index[TaskSource_index["SOURCE_CALL_INTELLIGENCE"] = 1] = "SOURCE_CALL_INTELLIGENCE";
    TaskSource_index[TaskSource_index["SOURCE_TASK_CENTER"] = 2] = "SOURCE_TASK_CENTER";
    TaskSource_index[TaskSource_index["SOURCE_MESSAGING"] = 3] = "SOURCE_MESSAGING";
})(TaskSource_index || (TaskSource_index = {}));
export var FilterType;
(function (FilterType) {
    FilterType["FILTER_BY_UNKNOWN"] = "FILTER_BY_UNKNOWN";
    FilterType["FILTER_BY_TASK_ID"] = "FILTER_BY_TASK_ID";
    FilterType["FILTER_BY_LOCATION"] = "FILTER_BY_LOCATION";
    FilterType["FILTER_BY_SOURCE"] = "FILTER_BY_SOURCE";
    FilterType["FILTER_BY_STATUS"] = "FILTER_BY_STATUS";
    FilterType["FILTER_BY_ASSIGNEE"] = "FILTER_BY_ASSIGNEE";
    FilterType["FILTER_BY_SOURCE_ID"] = "FILTER_BY_SOURCE_ID";
    FilterType["FILTER_BY_TYPE"] = "FILTER_BY_TYPE";
    FilterType["FILTER_BY_AUTHOR"] = "FILTER_BY_AUTHOR";
    FilterType["FILTER_BY_ORG_ID"] = "FILTER_BY_ORG_ID";
    FilterType["FILTER_BY_PRIORITY"] = "FILTER_BY_PRIORITY";
})(FilterType || (FilterType = {}));
export var FilterType_index;
(function (FilterType_index) {
    FilterType_index[FilterType_index["FILTER_BY_UNKNOWN"] = 0] = "FILTER_BY_UNKNOWN";
    FilterType_index[FilterType_index["FILTER_BY_TASK_ID"] = 1] = "FILTER_BY_TASK_ID";
    FilterType_index[FilterType_index["FILTER_BY_LOCATION"] = 2] = "FILTER_BY_LOCATION";
    FilterType_index[FilterType_index["FILTER_BY_SOURCE"] = 3] = "FILTER_BY_SOURCE";
    FilterType_index[FilterType_index["FILTER_BY_STATUS"] = 4] = "FILTER_BY_STATUS";
    FilterType_index[FilterType_index["FILTER_BY_ASSIGNEE"] = 5] = "FILTER_BY_ASSIGNEE";
    FilterType_index[FilterType_index["FILTER_BY_SOURCE_ID"] = 6] = "FILTER_BY_SOURCE_ID";
    FilterType_index[FilterType_index["FILTER_BY_TYPE"] = 7] = "FILTER_BY_TYPE";
    FilterType_index[FilterType_index["FILTER_BY_AUTHOR"] = 8] = "FILTER_BY_AUTHOR";
    FilterType_index[FilterType_index["FILTER_BY_ORG_ID"] = 9] = "FILTER_BY_ORG_ID";
    FilterType_index[FilterType_index["FILTER_BY_PRIORITY"] = 10] = "FILTER_BY_PRIORITY";
})(FilterType_index || (FilterType_index = {}));
export var SortType;
(function (SortType) {
    SortType["SORT_UNKNOWN"] = "SORT_UNKNOWN";
    SortType["SORT_ASC"] = "SORT_ASC";
    SortType["SORT_DESC"] = "SORT_DESC";
})(SortType || (SortType = {}));
export var SortType_index;
(function (SortType_index) {
    SortType_index[SortType_index["SORT_UNKNOWN"] = 0] = "SORT_UNKNOWN";
    SortType_index[SortType_index["SORT_ASC"] = 1] = "SORT_ASC";
    SortType_index[SortType_index["SORT_DESC"] = 2] = "SORT_DESC";
})(SortType_index || (SortType_index = {}));
export var SortField;
(function (SortField) {
    SortField["SORT_FIELD_UNKNOWN"] = "SORT_FIELD_UNKNOWN";
    SortField["SORT_DUE_DATE"] = "SORT_DUE_DATE";
    SortField["SORT_PRIORITY"] = "SORT_PRIORITY";
})(SortField || (SortField = {}));
export var SortField_index;
(function (SortField_index) {
    SortField_index[SortField_index["SORT_FIELD_UNKNOWN"] = 0] = "SORT_FIELD_UNKNOWN";
    SortField_index[SortField_index["SORT_DUE_DATE"] = 1] = "SORT_DUE_DATE";
    SortField_index[SortField_index["SORT_PRIORITY"] = 2] = "SORT_PRIORITY";
})(SortField_index || (SortField_index = {}));
export var AggregateBy;
(function (AggregateBy) {
    AggregateBy["AGGREGATE_UNKNOWN"] = "AGGREGATE_UNKNOWN";
    AggregateBy["AGGREGATE_BY_TYPE"] = "AGGREGATE_BY_TYPE";
    AggregateBy["AGGREGATE_BY_STATUS"] = "AGGREGATE_BY_STATUS";
    AggregateBy["AGGREGATE_BY_SOURCE_ID"] = "AGGREGATE_BY_SOURCE_ID";
    AggregateBy["AGGREGATE_BY_LOCATION_ID"] = "AGGREGATE_BY_LOCATION_ID";
})(AggregateBy || (AggregateBy = {}));
export var AggregateBy_index;
(function (AggregateBy_index) {
    AggregateBy_index[AggregateBy_index["AGGREGATE_UNKNOWN"] = 0] = "AGGREGATE_UNKNOWN";
    AggregateBy_index[AggregateBy_index["AGGREGATE_BY_TYPE"] = 1] = "AGGREGATE_BY_TYPE";
    AggregateBy_index[AggregateBy_index["AGGREGATE_BY_STATUS"] = 2] = "AGGREGATE_BY_STATUS";
    AggregateBy_index[AggregateBy_index["AGGREGATE_BY_SOURCE_ID"] = 3] = "AGGREGATE_BY_SOURCE_ID";
    AggregateBy_index[AggregateBy_index["AGGREGATE_BY_LOCATION_ID"] = 4] = "AGGREGATE_BY_LOCATION_ID";
})(AggregateBy_index || (AggregateBy_index = {}));
export var PriorityType;
(function (PriorityType) {
    PriorityType["PRIORITY_UNKNOWN"] = "PRIORITY_UNKNOWN";
    PriorityType["PRIORITY_LOW"] = "PRIORITY_LOW";
    PriorityType["PRIORITY_MEDIUM"] = "PRIORITY_MEDIUM";
    PriorityType["PRIORITY_HIGH"] = "PRIORITY_HIGH";
})(PriorityType || (PriorityType = {}));
export var PriorityType_index;
(function (PriorityType_index) {
    PriorityType_index[PriorityType_index["PRIORITY_UNKNOWN"] = 0] = "PRIORITY_UNKNOWN";
    PriorityType_index[PriorityType_index["PRIORITY_LOW"] = 1] = "PRIORITY_LOW";
    PriorityType_index[PriorityType_index["PRIORITY_MEDIUM"] = 2] = "PRIORITY_MEDIUM";
    PriorityType_index[PriorityType_index["PRIORITY_HIGH"] = 3] = "PRIORITY_HIGH";
})(PriorityType_index || (PriorityType_index = {}));
export var Operator;
(function (Operator) {
    Operator["OPERATOR_UNSPECIFIED"] = "OPERATOR_UNSPECIFIED";
    Operator["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
    Operator["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
})(Operator || (Operator = {}));
export var Operator_index;
(function (Operator_index) {
    Operator_index[Operator_index["OPERATOR_UNSPECIFIED"] = 0] = "OPERATOR_UNSPECIFIED";
    Operator_index[Operator_index["GREATER_THAN_OR_EQUAL"] = 1] = "GREATER_THAN_OR_EQUAL";
    Operator_index[Operator_index["LESS_THAN_OR_EQUAL"] = 2] = "LESS_THAN_OR_EQUAL";
})(Operator_index || (Operator_index = {}));
export var Field;
(function (Field) {
    Field["FIELD_UNSPECIFIED"] = "FIELD_UNSPECIFIED";
    Field["CREATED_AT"] = "CREATED_AT";
    Field["UPDATED_AT"] = "UPDATED_AT";
    Field["DUE_DATE"] = "DUE_DATE";
})(Field || (Field = {}));
export var Field_index;
(function (Field_index) {
    Field_index[Field_index["FIELD_UNSPECIFIED"] = 0] = "FIELD_UNSPECIFIED";
    Field_index[Field_index["CREATED_AT"] = 1] = "CREATED_AT";
    Field_index[Field_index["UPDATED_AT"] = 2] = "UPDATED_AT";
    Field_index[Field_index["DUE_DATE"] = 3] = "DUE_DATE";
})(Field_index || (Field_index = {}));
